/**
 * ID Overview — Frontend ローカル Contract
 *
 * BE 側 `dresscode-backend/v2/src/it-force/api/it-id-management/usecase/id-management-overview.api-contract.ts`
 * と同じ Zod 構造を再現。BE が `@standandforce/api-contract` に publish された後、
 * client.ts でローカル import を置き換える想定。
 */
import { oc } from '@orpc/contract';
import { z } from 'zod';
const IdOverviewIndividualCategorySchema = z.enum(['EMPLOYEE_ID', 'BOARD_MEMBER_ID', 'CONTRACTOR_ID', 'COLLABORATOR_ID', 'PERSONAL_ID']);
const IdOverviewRecentItemSchema = z.object({
  proxyUserId: z.string(),
  loginId: z.string(),
  occurredAt: z.string()
});
const IdOverviewGroupItemSchema = z.object({
  proxyUserId: z.string(),
  name: z.string(),
  memberCount: z.number()
});
const IdManagementOverviewCountSchema = z.object({
  total: z.number(),
  individualTotal: z.number(),
  groupTotal: z.number(),
  individualBreakdown: z.array(z.object({
    category: IdOverviewIndividualCategorySchema,
    count: z.number()
  })),
  // 登録推移（直近12ヶ月・古い順）: proxy_user.created_at 基準
  monthly: z.array(z.object({
    month: z.string(),
    cumulativeCount: z.number(),
    addedCount: z.number()
  })),
  // 最近追加されたID（作成日時降順・上位6件）
  recent: z.array(IdOverviewRecentItemSchema),
  // 最近のグループID（作成日時降順・上位5件。名前＋メンバー数）
  recentGroups: z.array(IdOverviewGroupItemSchema)
});
export const idOverviewContract = oc.router({
  count: oc.route({
    method: 'GET',
    path: '/v2/id-management/overview/count'
  }).output(IdManagementOverviewCountSchema)
});
export type IdOverviewIndividualCategory = z.infer<typeof IdOverviewIndividualCategorySchema>;
export type IdManagementOverviewCount = z.infer<typeof IdManagementOverviewCountSchema>;
export type IdOverviewRecentItem = z.infer<typeof IdOverviewRecentItemSchema>;
export type IdOverviewGroupItem = z.infer<typeof IdOverviewGroupItemSchema>;